import React from 'react';
import { Stage, Layer, Image as KonvaImage, Line, Text, Group } from 'react-konva';
import useImage from 'use-image';
import { CircularProgress, Box } from '@mui/material';

const InteractiveImage = ({ imageUrl, faces, selectedFaceId, onFaceClick, onStageClick, containerSize }) => {
  const [image, imageStatus] = useImage(imageUrl);

  const isImageLoaded = imageStatus === 'loaded';
  const isContainerSized = containerSize.width > 0 && containerSize.height > 0;
  
  let stageWidth = 0;
  let stageHeight = 0;
  let scale = 1;

  if (isImageLoaded && isContainerSized) {
    const originalWidth = image.width;
    const originalHeight = image.height;
    const widthScale = containerSize.width / originalWidth;
    const heightScale = containerSize.height / originalHeight;
    scale = Math.min(widthScale, heightScale, 1);
    stageWidth = originalWidth * scale;
    stageHeight = originalHeight * scale;
  }
  
  const handleStageClick = (e) => {
    if (e.target.getClassName() === 'Image') {
      onStageClick();
    }
  };

  if (!isImageLoaded || !isContainerSized) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Stage 
      width={stageWidth} 
      height={stageHeight} 
      onClick={handleStageClick}
      onTap={handleStageClick}
    >
      <Layer>
        <KonvaImage 
          image={image} 
          width={stageWidth}
          height={stageHeight}
        />
        
        {faces.map((face) => {
          const scaledPoints = face.drawable_bbox.map(point => point * scale);
          const isSelected = face.id === selectedFaceId;
          const isKnownIdentity = ! (face.assigned_identity === "Unknown Identity"); // Check if identity is known

          const FONT_TO_BBOX_RATIO = 0.15;
          const MIN_BASE_FONT_SIZE = 12;
          const MAX_BASE_FONT_SIZE = 22;

          const bboxWidth = face.drawable_bbox[2] - face.drawable_bbox[0];
          let baseFontSize = bboxWidth * FONT_TO_BBOX_RATIO;
          baseFontSize = Math.max(MIN_BASE_FONT_SIZE, Math.min(baseFontSize, MAX_BASE_FONT_SIZE));
          
          const label = `${face.assigned_identity || 'Unknown'}: ${Math.round(face.predicted_age)} yrs`;

          return (
            <Group
              key={face.id}
              onClick={() => onFaceClick(face.id)}
              onTap={() => onFaceClick(face.id)}
            >
              <Line
                points={scaledPoints}
                // --- THIS IS THE MODIFIED LINE ---
                stroke={isSelected ? 'cyan' : (isKnownIdentity ? 'lime' : 'red')}
                strokeWidth={isSelected ? 4 : 2}
                fill={isSelected ? "rgba(0, 255, 255, 0.3)" : "rgba(0,0,0,0)"}
                closed={true}
              />
              <Text
                x={scaledPoints[0]}
                y={scaledPoints[1] - (baseFontSize + 5) * scale}
                text={label}
                fontSize={baseFontSize * scale}
                fill="white"
                fontStyle="bold"
                background="rgba(0,0,0,0.6)"
                padding={4 * scale}
                cornerRadius={3 * scale}
              />
            </Group>
          );
        })}
      </Layer>
    </Stage>
  );
};

export default InteractiveImage;